import React from 'react';



import { DatePicker, Tooltip, Tree } from 'antd';
import moment from 'moment';



import YearMonthPicker from 'components/admin/YearMonthPicker';
import CustomDateTimeSelect from 'components/base/CustomDateTimeSelect';
import CustomRadios from 'components/base/CustomRadios';
import CustomSwitchButton from 'components/base/CustomSwitchButton';
import { CustomInput } from 'components/base/CustomTitleWithInput';
import CheckboxItem from 'components/coupon/couponList/CheckboxItem';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { ADDITIONAL_FIELD_FORMAT_TYPE, CUSTOMER_FIELD_NAME_LABELS, CUSTOM_ADDITIONAL_FIELD_FORMAT_TYPE, TICKET_CAMPAIGN_OTHER_INFORMATION_QUSETION_TYPE } from 'config/CustomEnums';



import { removeElementFromArray } from 'utils';
import { TimeFormater } from 'utils/TimeFormatUtil';



import './TicketOtherInformationField.scss';


export default function TicketOtherInformationField({
  data,
  customerAdditionalDataFields,
  defaultValue = null,
  useDefaultValue = true,
  setValue = () => {},
  error = {},
}) {
  const { fieldLabel, fieldFormat, isOptional, questionType } = data;
  let fieldOptions = data.fieldOptions || [];

  if (
    questionType ===
    TICKET_CAMPAIGN_OTHER_INFORMATION_QUSETION_TYPE.CUSTOMER_PROFILE_FIELD
  ) {
    if (CUSTOMER_FIELD_NAME_LABELS.GENDER === fieldLabel) {
      fieldOptions = [
        { label: 'Male', value: 'MALE' },
        { label: 'Female', value: 'FEMALE' },
        { label: 'Not disclosed', value: 'NOT_DISCLOSED' },
      ];
    }
  }

  let showTitle = true;
  let inputComponent = null;
  if (fieldFormat === CUSTOM_ADDITIONAL_FIELD_FORMAT_TYPE.DATE_MONTH) {
    inputComponent = (
      <YearMonthPicker
        defaultValue={defaultValue}
        setValue={(value) => {
          setValue(value);
        }}
        placeholder={`Birth Month & Year${isOptional ? ' (Optional)' : ''}`}
      />
    );
  } else if (
    [
      ADDITIONAL_FIELD_FORMAT_TYPE.TEXT,
      ADDITIONAL_FIELD_FORMAT_TYPE.NUMBER,
    ].includes(fieldFormat)
  ) {
    inputComponent = (
      <>
        <CustomInput
          containerCustomClass={'ticket-other-information-text-container'}
          type={
            ADDITIONAL_FIELD_FORMAT_TYPE.TEXT === fieldFormat
              ? 'text'
              : 'number'
          }
          onChange={({ target }) => setValue(target.value)}
          {...(useDefaultValue
            ? { defaultValue: defaultValue || '' }
            : { value: defaultValue || '' })}
          value={defaultValue}
          // placeholder={isOptional ? `${fieldLabel} (Optional)` : fieldLabel}
          placeholder={'Please input'}
          error={error.error}
        />
      </>
    );
  } else if (fieldFormat === ADDITIONAL_FIELD_FORMAT_TYPE.DATETIME) {
    inputComponent = (
      <>
        <div className="date-pick-container">
          <DatePicker
            showNow={false}
            value={
              defaultValue
                ? moment(defaultValue, TimeFormater.yearMonthDayTime)
                : null
            }
            showTime={{ format: TimeFormater.timePeriod }}
            format={TimeFormater.yearMonthDayTimePeriod}
            onChange={(date, dateString) => {
              if (!dateString) {
                setValue(null);
              }
            }}
            onOk={(value) => {
              setValue(value?.format(TimeFormater.yearMonthDayTime));
            }}
            popupStyle={{ position: 'fixed' }}
            // getPopupContainer={(trigger) => {
            //   return trigger.parentNode;
            // }}
          />
        </div>
      </>
    );
  } else if (
    [
      ADDITIONAL_FIELD_FORMAT_TYPE.TOGGLE,
      ADDITIONAL_FIELD_FORMAT_TYPE.CHECKBOX,
    ].includes(fieldFormat)
  ) {
    inputComponent = (
      <>
        <CustomSwitchButton
          defaultChecked={defaultValue}
          onChange={(isChecked) => {
            setValue(isChecked);
          }}
        />
      </>
    );
  } else if (fieldFormat === ADDITIONAL_FIELD_FORMAT_TYPE.DROPDOWN) {
    inputComponent = (
      <>
        <CustomTitleWithDropDown
          needFilter={false}
          labelContainPk={false}
          defaultValue={defaultValue}
          source={fieldOptions?.map((item) => ({
            value: item.value,
            name: item.label,
          }))}
          setValue={setValue}
          loadMoreAction=""
          filterAction=""
          customClass={'width-400px'}
        />
      </>
    );
  } else if (fieldFormat === ADDITIONAL_FIELD_FORMAT_TYPE.SINGLE_CHOICES) {
    inputComponent = (
      <>
        <div className="single-choices-container" style={{ display: 'flex' }}>
          <CustomRadios
            onChange={(value) => {
              setValue(value);
            }}
            default={defaultValue}
            options={fieldOptions}
          />
        </div>
      </>
    );
  } else if (fieldFormat === ADDITIONAL_FIELD_FORMAT_TYPE.MULTI_CHOICES) {
    inputComponent = (
      <>
        <div className="multiple-choices-container" style={{ display: 'flex' }}>
          {fieldOptions?.map((item, index) => {
            return (
              <>
                <CheckboxItem
                  index={index}
                  title={item.label}
                  defaultValue={
                    defaultValue && defaultValue.indexOf(item.value) > -1
                  }
                  onChange={() => {
                    if (defaultValue?.includes(item.value)) {
                      const newCheckedData = removeElementFromArray(
                        defaultValue,
                        item.value,
                      );
                      setValue(newCheckedData);
                    } else {
                      setValue([...(defaultValue || []), item.value]);
                    }
                  }}
                />
              </>
            );
          })}
        </div>
      </>
    );
  }

  return (
    <>
      {showTitle ? (
        <label className="create-section-label create-section-label-bottom-space">
          {isOptional ? `${fieldLabel} (Optional)` : fieldLabel}
        </label>
      ) : null}
      {inputComponent}
    </>
  );
}